// transforms.ts

export const transforms: any = {
  scale_0_4: (value?: number) => {
    switch (value) {
      case 0:
        return 'Jamais';
      case 1:
        return 'Presque jamais';
      case 2:
        return 'Parfois';
      case 3:
        return 'Assez souvent';
      case 4:
        return 'Très souvent';
      default:
        return '—';
    }
  },

  oui_non: (value?: number | boolean | string) => {
    if (value === 1 || value === true || value === '1') return 'Oui';
    if (value === 0 || value === false || value === '0') return 'Non';
    return '—';
  },

  pain_level: (value?: string) => {
    switch (value) {
      case 'UNBEARABLE':
        return 'Insupportable';
      case 'HIGH':
        return 'Élevé';
      case 'MODERATE':
        return 'Modéré';
      case 'LOW':
        return 'Faible';
      default:
        return '—';
    }
  },
};
